// ==================== ORGANISATIONS-FUNKTIONEN (GRÜN) ====================
// Based on the structure plan - Only green items
export const ORGANISATIONS_FEATURES = [
  { key: "schedule", label: "Zeitplan/Schedule", icon: "CalendarClock", color: "#0EA5E9", description: "Präzises Timing" },
  { key: "dresscode", label: "Dresscode", icon: "Shirt", color: "#A855F7", description: "Was ziehen wir an?" },
  { key: "carpool", label: "Fahrgemeinschaften", icon: "Car", color: "#22C55E", description: "Nachhaltig ankommen" },
  { key: "tasks", label: "Aufgabenliste", icon: "CheckSquare", color: "#6366F1", description: "To-Dos abhaken" },
  { key: "guest_who", label: "Gästeverwaltung", icon: "Users", color: "#3B82F6", description: "Wer kommt alles?" },
  { key: "location", label: "Standort/Location", icon: "MapPin", color: "#22C55E", description: "Event-Ort & Anreise" },
  { key: "seating_plan", label: "Sitzplan", icon: "Users", color: "#EAB308", description: "Wer sitzt wo?" },
];

// ==================== MITMACHEN / SPIELE (GRÜN) ====================
// Based on the structure plan - Only green items
export const MITMACHEN_FEATURES = [
  { key: "selfie_game", label: "Selfie-Spiel", icon: "Camera", color: "#EC4899", description: "Verrückte Foto-Challenges" },
  { key: "gamification", label: "Rangliste", icon: "Trophy", color: "#F59E0B", description: "Wer hat am meisten Punkte?" },
  { key: "dish_voting", label: "Gerichtsvoting", icon: "UtensilsCrossed", color: "#F59E0B", description: "Was schmeckt am besten?" },
  { key: "chat", label: "Chat", icon: "MessageSquare", color: "#3B82F6", description: "Nachrichten schreiben" },
  { key: "guestbook", label: "Gästebuch", icon: "BookOpen", color: "#F97316", description: "Liebe Worte & Fotos" },
];

// ==================== MEDIEN (GRÜN + MANUELLE AUSWAHL) ====================
// Based on the structure plan + manual additions
export const MEDIEN_FEATURES = [
  { key: "photo_upload", label: "Bilder-Upload", icon: "Image", color: "#EC4899", description: "Fotos teilen & sammeln" },
  { key: "video_upload", label: "Video-Upload", icon: "Video", color: "#5865F2", description: "Teile Clips vom Event" },
  { key: "music_upload", label: "Musik-Upload", icon: "Music", color: "#D3B0FF", description: "Lade deine Lieblingssongs hoch" },
  { key: "wishlist", label: "Geschenk-Wünsche", icon: "Gift", color: "#EF4444", description: "Was wir uns freuen" },
  { key: "media_download", label: "Datei-Download", icon: "Download", color: "#6366F1", description: "Alle Event-Medien als ZIP" },
];

// ==================== ARCHIVIERTE FUNKTIONEN ====================
// Features that were present but are not marked green in the current plan
export const ARCHIVED_FEATURES = [
  { key: "timeline", label: "Timeline", icon: "Clock", color: "#06B6D4", description: "Der rote Faden" },
  { key: "budget", label: "Budget-Planer", icon: "DollarSign", color: "#22C55E", description: "Finanzen im Blick" },
  { key: "tips", label: "Tipps", icon: "Lightbulb", color: "#F59E0B", description: "Wichtige Infos" },
  { key: "bucket_list", label: "Bucket List", icon: "ListChecks", color: "#EC4899", description: "Noch zu erledigen" },
  { key: "yearbook", label: "Digitales Jahrbuch", icon: "Book", color: "#3B82F6", description: "Eure Momente" },
  { key: "employee_spotlight", label: "Mitarbeiter-Spotlight", icon: "Star", color: "#F97316", description: "Team im Fokus" },
  { key: "workshop_docs", label: "Workshop-Dokumente", icon: "FileText", color: "#6B7280", description: "Alle Unterlagen" },
  { key: "matching_tool", label: "Matching-Tool", icon: "Heart", color: "#3B82F6", description: "Finde dein Gegenstück" },
  { key: "face_voting", label: "Gesichtsvoting", icon: "Users", color: "#F97316", description: "Wer hat das beste Lächeln?" },
  { key: "name_advisor", label: "Namensberater", icon: "UserPlus", color: "#6366F1", description: "Kreative Namensfindung" },
  { key: "year_review", label: "Jahresrückblick", icon: "Calendar", color: "#22C55E", description: "Die Highlights" },
  { key: "secret_santa", label: "Wichteln", icon: "Snowflake", color: "#EF4444", description: "Wer beschenkt wen?" },
  { key: "memory_box", label: "Erinnerungs-Box", icon: "Box", color: "#F97316", description: "Schätze sammeln" },
  { key: "gender_guess", label: "Gender-Guess", icon: "HelpCircle", color: "#06B6D4", description: "Boy or Girl?" },
  { key: "team_missions", label: "Team-Missionen", icon: "Target", color: "#4F46E5", description: "Gemeinsam stark" },
  { key: "vision_board", label: "Vision Board", icon: "Image", color: "#8B5CF6", description: "Eure Zukunftsträume" },
  { key: "audio_upload", label: "Audio-Upload", icon: "Mic", color: "#98E6C1", description: "Sprachnachrichten & Grüße" },
];

// ==================== ALL FEATURES (flat list for reference) ====================
export const ALL_FEATURES_NEW = {
  // Aktiv (Grün im Strukturplan + Ergänzungen)
  schedule: "Zeitplan/Schedule",
  dresscode: "Dresscode",
  carpool: "Fahrgemeinschaften",
  dish_voting: "Gerichtsvoting",
  tasks: "Aufgabenliste",
  selfie_game: "Selfie-Spiel",
  gamification: "Rangliste",
  photo_upload: "Bilder-Upload",
  video_upload: "Video-Upload",
  music_upload: "Musik-Upload",
  media_download: "Datei-Zentrale",

  // Archiviert
  guestbook: "Gästebuch",
  chat: "Chat",
  location: "Standort/Location",
  wishlist: "Geschenk-Wünsche",
  audio_upload: "Audio-Upload",
  seating_plan: "Sitzplan",
  budget: "Budget-Planer",
  tips: "Tipps",
  timeline: "Timeline",
  name_advisor: "Namensberater",
  year_review: "Jahresrückblick",
  bucket_list: "Bucket List",
  memory_box: "Erinnerungs-Box",
  vision_board: "Vision Board",
  yearbook: "Digitales Jahrbuch",
  face_voting: "Gesichtsvoting",
  gender_guess: "Gender-Guess",
  secret_santa: "Wichteln",
  matching_tool: "Matching-Tool",
  team_missions: "Team-Missionen",
  employee_spotlight: "Mitarbeiter-Spotlight",
  guest_who: "Wer ist das?",
  workshop_docs: "Workshop-Dokumente",
};

// Default features that are always enabled (Grün im Strukturplan + Ergänzungen)
export const DEFAULT_FEATURES = [
  "schedule",
  "dresscode",
  "carpool",
  "dish_voting",
  "tasks",
  "selfie_game",
  "gamification",
  "photo_upload",
  "video_upload",
  "music_upload",
  "media_download",
  "guest_who",
  "chat",
  "guestbook",
];

/**
 * Check if feature is enabled based on backend response
 */
export function isFeatureEnabled(featureKey, enabledFeatures) {
  // If no features loaded yet, show defaults
  if (!enabledFeatures || Object.keys(enabledFeatures).length === 0) {
    return DEFAULT_FEATURES.includes(featureKey);
  }

  const value = enabledFeatures[featureKey];

  // If explicitly set to false, it's disabled
  if (value === false) {
    return false;
  }

  // If true or null/undefined, it's enabled if it's in the current active list
  // or if it was explicitly enabled in backend
  const isActive = [...ORGANISATIONS_FEATURES, ...MITMACHEN_FEATURES, ...MEDIEN_FEATURES].some(f => f.key === featureKey);

  return (value === true && isActive) || (DEFAULT_FEATURES.includes(featureKey));
}

/**
 * Get all active features as a flat array for iteration
 */
export function getAllFeaturesFlat() {
  return [
    ...ORGANISATIONS_FEATURES,
    ...MITMACHEN_FEATURES,
    ...MEDIEN_FEATURES,
  ];
}
